export const BEGIN_FETCH_SPONSORED_PRODUCTS = 'BEGIN_FETCH_SPONSORED_PRODUCTS';
export const FETCH_SPONSORED_PRODUCTS_SUCCESS = 'FETCH_SPONSORED_PRODUCTS_SUCCESS';
export const FETCH_SPONSORED_PRODUCTS_ERROR = 'FETCH_SPONSORED_PRODUCTS_ERROR';
export const FETCH_SPONSORED_PRODUCT_HEART_LIST_ERROR = 'FETCH_SPONSORED_PRODUCT_HEART_LIST_ERROR';
export const BEGIN_FETCH_SYMPHONY_SEARCH_COMPONENTS = 'BEGIN_FETCH_SYMPHONY_SEARCH_COMPONENTS';
export const RECEIVE_SYMPHONY_SEARCH_COMPONENTS = 'RECEIVE_SYMPHONY_SEARCH_COMPONENTS';
export const FETCH_SYMPHONY_SEARCH_COMPONENTS_ERROR = 'FETCH_SYMPHONY_SEARCH_COMPONENTS_ERROR';
